import { useState } from 'react'
import type { JSX } from 'react'

import { Text } from '@buffer-mono/popcorn'

import { MENTIONS_CAPABILITIES } from '../CommunityConfig'
import { EngagementAvatar } from '../components/EngagementAvatar'
import { EngagementHeader } from '../components/EngagementHeader'
import { EngagementItem } from '../components/EngagementItem'
import {
  getMentionCardAriaLabel,
  MentionCardView,
} from '../Mentions/MentionCard/MentionCard'
import { MentionPrefixView } from '../Mentions/MentionCard/MentionPrefix'
import { MentionText } from '../Mentions/MentionCard/MentionText'
import { MentionThreadFrame } from '../Mentions/MentionCard/MentionThreadContent'

import { EXAMPLE_MENTIONED_ACCOUNT } from './exampleMentions'
import type { ExampleMention } from './exampleMentions'

export function PublicExampleMentionCard({
  mention,
}: {
  mention: ExampleMention
}): JSX.Element {
  const [publishedAt] = useState(() =>
    new Date(Date.now() - mention.minutesAgo * 60_000).toISOString(),
  )
  const channel = { service: mention.service }
  const headerId = `example-mention-header-${mention.id}`

  return (
    <MentionCardView
      mentionId={mention.id}
      expanded={false}
      dismissed={false}
      resolved={false}
      dimmed={false}
      ariaLabel={getMentionCardAriaLabel(mention.authorName, mention.text)}
    >
      <MentionThreadFrame
        mentionId={mention.id}
        username={mention.authorName}
        status="unreplied"
        isOwnEngagement={false}
      >
        <EngagementItem
          variant="root"
          aria-labelledby={headerId}
          avatar={
            <EngagementAvatar
              avatar=""
              username={mention.authorName}
              channel={channel}
              showConnector={false}
            />
          }
        >
          <EngagementHeader
            id={headerId}
            username={
              <Text weight="bold" translate="no">
                {mention.authorName}
              </Text>
            }
            timestamp={publishedAt}
          />
          <MentionPrefixView
            label={
              MENTIONS_CAPABILITIES.showPrefix(channel)
                ? MENTIONS_CAPABILITIES.subjectLabel(
                    channel,
                    mention.mentionType,
                  )
                : undefined
            }
          />
          <MentionText
            text={mention.text}
            channel={EXAMPLE_MENTIONED_ACCOUNT}
          />
        </EngagementItem>
      </MentionThreadFrame>
    </MentionCardView>
  )
}
